module.exports = __webpack_public_path__ + "static/img/2025封面中文.81bb471.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2025封面中文.jpg
// module id = hwOa
// module chunks = 1